import { render, staticRenderFns } from "./PriorityModal.vue?vue&type=template&id=cdf5ad0c&"
import script from "./PriorityModal.vue?vue&type=script&lang=js&"
export * from "./PriorityModal.vue?vue&type=script&lang=js&"
import style0 from "./PriorityModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports